var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data_page"},[_c('van-icon',{staticClass:"icon_box",attrs:{"name":_vm.url}}),_c('div',{staticClass:"text_p"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }